/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NotificationImageVariant {
    LOGO = 'Logo',
    MAIN_IMAGE = 'MainImage',
    FIRST_IMAGE = 'FirstImage',
}
